import { render, staticRenderFns } from "./NewBookings.vue?vue&type=template&id=147f537e"
import script from "./NewBookings.vue?vue&type=script&lang=js"
export * from "./NewBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports